const SHARE_BASE_URL = 'https://twinklestarknights-library.pages.dev';

function encodeBase64Url(value) {
  return btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

function decodeBase64Url(value) {
  const normalized = String(value).replace(/-/g, '+').replace(/_/g, '/');
  const padLength = (4 - (normalized.length % 4)) % 4;
  return atob(`${normalized}${'='.repeat(padLength)}`);
}

export function buildSharePayload(items) {
  return items
    .filter((item) => Boolean(item.possessed))
    .map((item) => {
      const rarity = Number(item.rarity) || 0;
      return `${item.id}.${rarity}`;
    })
    .join(',');
}

export function parseSharePayload(payload) {
  const map = new Map();
  if (!payload) return map;

  payload.split(',').forEach((entry) => {
    const [idRaw, rarityRaw] = entry.split('.');
    const id = String(idRaw || '').trim();
    if (!id) return;
    const rarity = Number(rarityRaw || 0);
    map.set(id, Number.isFinite(rarity) && rarity > 0 ? rarity : '');
  });

  return map;
}

export function extractShareMapFromSearch(search) {
  try {
    const params = new URLSearchParams(search || '');
    const raw = params.get('share');
    if (!raw) return null;
    return parseSharePayload(decodeBase64Url(raw));
  } catch (_error) {
    return null;
  }
}

export function buildShareUrl(items) {
  const payload = buildSharePayload(items);
  const encoded = encodeBase64Url(payload);
  return `${SHARE_BASE_URL}/shared?share=${encoded}`;
}

